import { Component } from '@angular/core';

@Component({
	templateUrl: './formlayoutdemo.component.html',
})
export class FormLayoutDemoComponent {
	selectedState: any = null;

	states: any[] = [
		{ name: 'Arizona', code: 'Arizona' },
		{ name: 'California', value: 'California' },
		{ name: 'Florida', code: 'Florida' },
		{ name: 'Ohio', code: 'Ohio' },
		{ name: 'Washington', code: 'Washington' },
	];
}
